import { useState } from 'react';
import { Button } from '../../../../components/form/button';
import { Modal } from '../../../../components/modal/modal';
import { Order } from '../../../../clients/quipli-service/order/order';
import { useYorentClient } from '../../../../clients/yorent/yorent-client';

export const useHourReadingModal = ({ order, refresh }: { order: Order; refresh: () => void }) => {
  const { addHourReadingFromQRLegacy } = useYorentClient();

  const [hourReadingModalOpen, setHourReadingModalOpen] = useState<{
    open: boolean;
    unitId: number;
    unitName: string;
    productId: number;
    hour: number;
  }>({ open: false, unitId: 0, unitName: '', productId: 0, hour: 0 });

  const HourReadingModal = () => (
    <Modal
      title="Scan QR Code"
      isOpen={hourReadingModalOpen.open}
      close={() => {
        setHourReadingModalOpen({ open: false, productId: 0, unitId: 0, unitName: '', hour: 0 });
        return refresh();
      }}
    >
      <div className="bg-white p-5 md:w-[500px] flex flex-col items-center">
        <div className="min-w-full h-[44px] p-[10px] flex items-center gap-3">
          Unit: {hourReadingModalOpen.unitName}
        </div>
        <div className="min-w-full h-[44px] p-[10px] flex items-center gap-3">
          <span className="quipli-v2 text-md">Machine Hours:</span>
          <input
            type="text"
            className="quipli-v2 text-md"
            value={hourReadingModalOpen.hour}
            onChange={(e) => setHourReadingModalOpen({ ...hourReadingModalOpen, hour: +e.target.value })}
          />
        </div>
        <Button
          className="button button-primary"
          onClick={() => {
            addHourReadingFromQRLegacy(
              order.id,
              hourReadingModalOpen.productId,
              hourReadingModalOpen.unitId,
              hourReadingModalOpen.hour,
            )
              .then(() => {})
              .catch(() => {})
              .finally(() => {
                setHourReadingModalOpen({ open: false, productId: 0, unitId: 0, unitName: '', hour: 0 });
                return refresh();
              });
          }}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );

  return { hourReadingModalOpen, setHourReadingModalOpen, HourReadingModal };
};
